const withPlusPrefix = (value: string | number): string => `+${value}`;

export default withPlusPrefix;
